import React from "react";
import {Alert, AlertDescription} from "@root/server/client/esweb/components/ui/alert.tsx";
import {AlertCircle} from "lucide-react";
import {cn} from "@root/server/client/esweb/lib/utils.ts";

interface FormServerErrorsProps {
    errors?: string[];
    className?: string;
}

export function FormServerErrors({errors, className}: FormServerErrorsProps) {
    if (!errors || errors.length === 0) {
        return null;
    }

    return (
        <Alert variant="destructive" className={cn(className)}>
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>
                <ul className="list-inside list-disc space-y-1">
                    {errors.map((error, index) => (
                        <li key={`${index}-${error}`}>{error}</li>
                    ))}
                </ul>
            </AlertDescription>
        </Alert>
    );
}
